module.exports = __webpack_public_path__ + "assets/img/qr_code-a1c5218e.jpg";